import { DateTime as DateTimeLuxon } from 'luxon'
import { Accordion } from 'primereact/accordion'
import { Card } from 'primereact/card'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { TabPanel } from 'primereact/tabview'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FaEye } from 'react-icons/fa'
import { azul_escuro, laranja, vinho } from '../../../../assets/js/colors'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Badge,
  BadgeStatusEntrega,
  Btn,
  Cnpj,
  ConfirmDialog,
  CustomAccordionTab,
  CustomDataTableHeader,
  CustomInputTextArea,
  CustomDataTable,
  CustomModal,
  CustomPanel,
  CustomTabView,
  DateTime,
  Loading,
  NumeroDecimal,
  PageHeader,
} from '../../../../components'
import CicloEntregaAcoesHttp from '../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import * as DeliveryHttp from '../../../../services/api/https/deliveries/delivery.http'
import {
  getDeliveryTimeline,
  getNotasFiscaisDevolucao,
  getOcorrenciasEntregaPorEntrega,
} from '../../../../services/api/https/deliveries/delivery.http'
import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import {
  ocorrenciasPorEntrega,
  palletAreaPorEntrega,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

const ABA_OCORRENCIA = {
  PRODUTO: 0,
  ENTREGA: 1,
}

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'Alterando dados entrega entrega',
  SUCCESS: 'Entrega alterada com sucesso',
}

const INITIAL_STATE = {
  entrega: {
    delivery_step_id: 0,
    delivery_id: 0,
    identifier: '0',
    invoice_number: null,
    nomeFantasia: '',
    city: '',
    address: '',
    number: '',
    district: '',
    cnpj: '',
    qteSkuTotal: 0,
    status: '',
    dt_status: '',
    path_canhoto: null,
    path_nf_dev_total: null,
    observation: '',
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function EntregaDetalhes({ history, dispatch }) {
  // Vars
  const { entrega } = history.location.state
  const [state, setState] = useState({ ...INITIAL_STATE })
  const [showDeleteCanhoto, setShowDeleteCanhoto] = useState(false)
  const [isDeletingCanhoto, setIsDeletingCanhoto] = useState(false)

  // Hooks
  useEffect(() => {
    if (entrega) {
      setState(prevState => {
        prevState.entrega = { ...prevState.entrega, ...entrega }
        return { ...prevState }
      })
    }
  }, [entrega])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        alterarEntrega(state.entrega)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  // Events
  const onTimelineError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onNFDevolucaoError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onBtnSalvarClicked = () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
  }

  const alterarEntrega = entrega => {
    const updatedDelivery = {
      id: entrega.delivery_id,
      observation: entrega.observation,
    }
    DeliveryHttp.updateDelivery(updatedDelivery)
      .then(() => {
        setState(prevState => {
          prevState.loadingMessage = LOAD_MESSAGE.SUCCESS
          return { ...prevState }
        })
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const onConfirmDeleteCanhoto = async () => {
    try {
      setIsDeletingCanhoto(true)
      dispatch(showLoadingBox('Excluindo canhoto...'))

      const src = (state.entrega.path_canhoto || '').split('?')[0]
      const parts = src.split('/')
      const filename = parts[parts.length - 1]

      // apaga no S3 via co-log-doc-repo
      await RetornoHttp.deleteDeliveryCanhotoFile(filename)

      // zera referência no banco via co-log-api
      await RetornoHttp.putUpdateDeliveryPaths(state.entrega.delivery_id, 'canhoto', null)

      setState(prevState => ({
        ...prevState,
        entrega: { ...prevState.entrega, path_canhoto: null, com_canhoto: false },
      }))

      dispatch(showMessageBox('Canhoto excluído com sucesso.', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsDeletingCanhoto(false)
      setShowDeleteCanhoto(false)
      dispatch(hideLoadingBox())
    }
  }

  // Helpers

  const handleDownloadCanhoto2 = async imagePath => {
    try {
      const blob = await CicloEntregaAcoesHttp.downloadCanhoto(imagePath)
      const url = window.URL.createObjectURL(blob)
      const fileName = imagePath.split('/').pop() || 'canhoto.jpeg'

      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(url)
    } catch (error) {
      dispatch(showMessageBox(null, 'Erro ao baixar o canhoto.'))
    }
  }

  // const handleDownloadCanhoto = async imagePath => {
  //   const fileName = imagePath.split('/').pop()
  //   const link = document.createElement('a')
  //   link.href = imagePath
  //   link.target = '_blank'
  //   link.download = fileName
  //   document.body.appendChild(link)
  //   link.click()
  //   document.body.removeChild(link)
  // }

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Entrega - &nbsp; <strong>Detalhes</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <CustomTabView activeIndex={0}>
            <TabPanel header="Dados">
              <DadosTab entrega={entrega} />
            </TabPanel>
            <TabPanel header="Timeline">
              <TimelineTab onError={onTimelineError} deliveryId={entrega.delivery_id} />
            </TabPanel>
            <TabPanel header="Canhoto">
              <div>
                {state.entrega.path_canhoto ? (
                  <>
                    <div className="p-mb-3">
                      <Btn onClick={() => handleDownloadCanhoto2(state.entrega.path_canhoto)}>
                        Baixar Canhoto
                      </Btn>{' '}
                      <Btn onClick={() => setShowDeleteCanhoto(true)} backgroundColor="#ee7387">
                        Excluir Canhoto
                      </Btn>
                    </div>

                    <div className="p-mb-2">
                      <img src={state.entrega.path_canhoto} alt="imagem canhoto" />
                    </div>

                    <ConfirmDialog
                      isVisible={showDeleteCanhoto}
                      title="Atenção"
                      content={<span>Tem certeza que deseja excluir o canhoto?</span>}
                      onCancelar={() => setShowDeleteCanhoto(false)}
                      onOk={onConfirmDeleteCanhoto}
                      disabled={isDeletingCanhoto}
                    />
                  </>
                ) : (
                  <span>Não Existe Imagem do Canhoto</span>
                )}
              </div>
            </TabPanel>
            <TabPanel header="NF. Entrega">
              <div>
                {entrega.path_nf_dev_total ? (
                  <img src={entrega.path_nf_dev_total} alt="imagem nota fiscal de entrega" />
                ) : (
                  <span>Não Existe Imagem da Nota Fiscal</span>
                )}
              </div>
            </TabPanel>
            <TabPanel header="NF. Devolução">
              <div>
                <NFDevolucaoTab deliveryId={entrega.delivery_id} onError={onNFDevolucaoError} />
              </div>
            </TabPanel>
            <TabPanel header="Ocorrências">
              <div>
                <OcorrenciasTab deliveryId={entrega.delivery_id} onError={onNFDevolucaoError} />
              </div>
            </TabPanel>
            <TabPanel header="Observações">
              <Card>
                {/*Observações*/}
                <form>
                  <CustomInputTextArea
                    label={'Observações'}
                    onChange={observation => {
                      setState(prevState => {
                        prevState.entrega.observation = observation
                        return { ...prevState }
                      })
                    }}
                    value={state.entrega.observation}
                    rows={4}
                  />
                  <Btn onClick={() => onBtnSalvarClicked(state)}>Salvar</Btn>
                </form>
              </Card>
            </TabPanel>
            <TabPanel header="Etiquetas">
              <div>
                <EtiquetasTab deliveryId={entrega.delivery_id} onError={onNFDevolucaoError} />
              </div>
            </TabPanel>
            <TabPanel header="Itens">
              <div className="p-grid">
                <ItensTab deliveryId={entrega.delivery_id} onError={onNFDevolucaoError} />
              </div>
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
    </React.Fragment>
  )

  function DadosTab({ entrega }) {
    //Vars
    const {
      identifier,
      invoice_number,
      nomeFantasia,
      cnpj,
      address,
      number,
      district,
      city,
      dt_status,
      qteSkuTotal,
      status,
      weightTotal,
      picking_id,
      picking_name,
      cycle_id,
      cycle_name,
      cycle_data_operacao,
      cycle_deadline,
      picking_style,
      valor_nf,
    } = entrega

    // Render
    return (
      <Card>
        <div className="p-grid">
          {/*Identificador*/}
          <div className="p-col-2">Identificador:</div>
          <div className="p-col-10 bold">{identifier}</div>

          {/*Nota Fiscal*/}
          <div className="p-col-2">Nº Nota Fiscal:</div>
          <div className="p-col-10 bold">{invoice_number}</div>

          {/*Nome Fantasia*/}
          <div className="p-col-2">Nome Fantasia:</div>
          <div className="p-col-10 bold">{nomeFantasia}</div>

          {/*CNPJ*/}
          <div className="p-col-2">CNPJ:</div>
          <div className="p-col-10 bold">
            <Cnpj>{cnpj}</Cnpj>
          </div>

          {/*Endereço*/}
          <div className="p-col-2">Endereço:</div>
          <div className="p-col-10 bold">{address}</div>

          {/*Número*/}
          <div className="p-col-2">Número:</div>
          <div className="p-col-10 bold">{number}</div>

          {/*Bairro*/}
          <div className="p-col-2">Bairro:</div>
          <div className="p-col-10 bold">{district}</div>

          {/*Cidade*/}
          <div className="p-col-2">Cidade:</div>
          <div className="p-col-10 bold">{city}</div>

          {/*Qte Sku*/}
          <div className="p-col-2">Quant. Caixas:</div>
          <div className="p-col-10 bold">{qteSkuTotal}</div>

          {/*Status*/}
          <div className="p-col-2">Status:</div>
          <div className="p-col-10">
            <BadgeStatusEntrega status={status} />
          </div>

          {/*Data Status*/}
          <div className="p-col-2">Data Status:</div>
          <div className="p-col-10 bold">
            <DateTime>{dt_status}</DateTime>
          </div>

          {/*Peso Nota*/}
          <div className="p-col-2">Peso Nota:</div>
          <div className="p-col-10 bold">
            <NumeroDecimal>{weightTotal}</NumeroDecimal> Kg
          </div>

          {/*Valor Nota*/}
          <div className="p-col-2">Valor Nota:</div>
          <div className="p-col-10 bold">
            {valor_nf ? (
              <>
                R$ <NumeroDecimal>{valor_nf}</NumeroDecimal>
              </>
            ) : (
              '-'
            )}
          </div>

          {/*Picking*/}
          <div className="p-col-2">Picking:</div>
          <div className="p-col-10 bold">{`${picking_id || ''} - ${picking_name || ''} - ${picking_style || ''}`}</div>

          {/*Cycle*/}
          <div className="p-col-2">Cycle:</div>
          <div className="p-col-10 bold">{`${cycle_id} - ${cycle_name}`}</div>

          {/*Ciclo - Data de operação*/}
          <div className="p-col-2">Ciclo - Data da Operação:</div>
          <div className="p-col-10 bold">
            <DateTime>{cycle_data_operacao}</DateTime>
          </div>

          {/*Ciclo - Deadline*/}
          <div className="p-col-2">Ciclo - Deadline:</div>
          <div className="p-col-10 bold">
            <DateTime>{cycle_deadline}</DateTime>
          </div>
        </div>
      </Card>
    )
  }

  function TimelineTab({ deliveryId, onError }) {
    // Hooks
    const [isLoading, setIsLoading] = useState(false)
    const [eventos, setEventos] = useState([])
    useEffect(() => {
      getEventos()
    }, [deliveryId])

    //Events
    const getEventos = async () => {
      try {
        setIsLoading(true)
        const fetchedEventos = await getDeliveryTimeline(deliveryId)
        setEventos(fetchedEventos)
      } catch (e) {
        onError(errorHandler(e))
      } finally {
        setIsLoading(false)
      }
    }

    // Rendering
    return isLoading ? (
      <div className="text-center">
        <Loading />
      </div>
    ) : (
      <div className="p-grid">
        {eventos.map((evento, index) => {
          const { status, created_at, description, tp, user, motivo_atraso } = evento
          return (
            <div className="p-col-12" key={index}>
              <Card style={{ paddingTop: 10, paddingBottom: 10 }}>
                <div style={{ display: 'flex' }}>
                  <div
                    style={{
                      width: 150,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <BadgeStatusEntrega status={status} />
                  </div>
                  <div>
                    <div style={{ fontSize: '0.7rem', color: vinho, fontStyle: 'italic' }}>
                      {DateTimeLuxon.fromISO(created_at).toFormat('dd/MM/yyyy HH:mm')}
                    </div>
                    <div>
                      {description} {motivo_atraso ? ` - ${motivo_atraso}` : ''}
                    </div>
                    <div style={{ fontSize: '0.7rem', color: azul_escuro }}>{tp}</div>
                    <div style={{ fontSize: '0.7rem', color: '#c4c4c4', fontStyle: 'italic' }}>
                      {user}
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          )
        })}
      </div>
    )
  }

  function NFDevolucaoTab({ deliveryId, onError }) {
    // Hooks
    const [isLoading, setIsLoading] = useState(true)
    const [notas, setNotas] = useState([])
    useEffect(() => {
      fetchNotas()
    }, [deliveryId])

    // Events

    // Helpers
    const fetchNotas = async () => {
      try {
        setIsLoading(true)
        const fetchedNotas = await getNotasFiscaisDevolucao(deliveryId)
        setNotas(fetchedNotas)
      } catch (e) {
        onError(errorHandler(e))
      } finally {
        setIsLoading(false)
      }
    }
    // Render
    return isLoading ? (
      <div className="text-center">
        <Loading />
      </div>
    ) : notas.length === 0 ? (
      <span>Não existe Nota de Fiscal de Devolução</span>
    ) : (
      notas.map((nota, index) => {
        return (
          <div key={index} className="text-center">
            <div
              className="text-center"
              style={{
                backgroundColor: azul_escuro,
                color: '#FFF',
                padding: 10,
              }}
            >
              Nº da Nota: &nbsp; {nota.invoice_number}
            </div>
            <img style={{ width: '100%' }} src={nota.invoice_path} alt="Nota Fiscal" />
          </div>
        )
      })
    )
  }

  function OcorrenciasTab({ deliveryId, onError }) {
    //Hooks
    const [abaOcorrencia, setAbaOcorrencia] = useState(ABA_OCORRENCIA.PRODUTO)
    const [isLoading, setIsLoading] = useState(true)
    const [ocorrenciasProduto, setOcorrenciasProduto] = useState([])
    const [ocorrenciasEntrega, setOcorrenciasEntrega] = useState([])

    useEffect(() => {
      fetchOcorrencias()
    }, [deliveryId, abaOcorrencia])

    // Helpers
    // Cada tipo é buscado somente quando sua guia é aberta (tela apenas de consulta)
    const fetchOcorrencias = async () => {
      try {
        setIsLoading(true)
        if (abaOcorrencia === ABA_OCORRENCIA.PRODUTO) {
          setOcorrenciasProduto(await ocorrenciasPorEntrega(deliveryId))
        } else {
          setOcorrenciasEntrega(await getOcorrenciasEntregaPorEntrega(deliveryId))
        }
      } catch (e) {
        onError(errorHandler(e))
      } finally {
        setIsLoading(false)
      }
    }

    const carregando = (
      <div className="text-center">
        <Loading />
      </div>
    )

    return (
      <CustomTabView activeIndex={abaOcorrencia} onTabChange={setAbaOcorrencia}>
        <TabPanel header="Ocorrências de Produtos">
          {isLoading ? (
            carregando
          ) : (
            <DataTable
              value={ocorrenciasProduto}
              emptyMessage="Não existe ocorrência de produto para esta nota fiscal"
            >
              <Column field="product_code" header="Código" style={tableCellCentered()} />
              <Column field="product_name" header="Produto" />
              <Column field="reason" header="Ocorrência" style={tableCellCentered(180)} />
              <Column field="qte_missing" header="Qte. Faltas" style={tableCellCentered()} />
              <Column field="qte_adjusted" header="Qte. Correção" style={tableCellCentered()} />
              <Column
                field="adjust_justification"
                header="Justificativa"
                style={tableCellCentered(180)}
              />
              <Column
                field="stage"
                header="Etapa"
                style={tableCellCentered()}
                body={ocorrencia => (
                  <Badge color={ocorrencia.stage === 'Separacao' ? laranja : vinho}>
                    {ocorrencia.stage}
                  </Badge>
                )}
              />
            </DataTable>
          )}
        </TabPanel>

        <TabPanel header="Ocorrências de Entregas">
          {isLoading ? (
            carregando
          ) : (
            <DataTable
              value={ocorrenciasEntrega}
              emptyMessage="Não existe ocorrência de entrega para esta nota fiscal"
            >
              <Column field="descricao" header="Ocorrência" />
              <Column field="sigla" header="Sigla" style={tableCellCentered(120)} />
              <Column
                field="codigo_interno"
                header="Código Interno"
                style={tableCellCentered(160)}
              />
              <Column field="observacao" header="Observação" />
              <Column
                field="guilty_client_name"
                header="Cliente Ofensor"
                style={tableCellCentered(200)}
              />
              <Column
                field="registred_by_name"
                header="Registrado por"
                style={tableCellCentered(180)}
              />
              <Column
                header="Data"
                style={tableCellCentered(150)}
                body={ocorrencia => <DateTime>{ocorrencia.created_at}</DateTime>}
              />
            </DataTable>
          )}
        </TabPanel>
      </CustomTabView>
    )
  }

  function EtiquetasTab({ deliveryId, onError }) {
    //Hooks
    const [isLoading, setIsLoading] = useState(true)
    const [palletAreas, setPalletAreas] = useState([])
    const [pickings, setPickings] = useState([])
    const [activeIndex, setActiveIndex] = useState(0)
    const [globalFilter, setGlobalFilter] = useState([])

    useEffect(() => {
      fetchEtiquetas()
    }, [deliveryId])

    // Helpers
    const fetchEtiquetas = async () => {
      try {
        setIsLoading(true)
        const fetchedPalletAreas = await palletAreaPorEntrega(deliveryId)
        const pickings = Array.from(
          new Set(fetchedPalletAreas.map(palletArea => palletArea.picking_id)),
        )
        pickings.forEach((_, index) => {
          globalFilter.push('')
        })
        setGlobalFilter(globalFilter)
        setPickings(pickings)
        setPalletAreas(fetchedPalletAreas)
      } catch (e) {
        onError(errorHandler(e))
      } finally {
        setIsLoading(false)
      }
    }
    return isLoading ? (
      <div className="text-center">
        <Loading />
      </div>
    ) : (
      <Accordion activeIndex={activeIndex} onTabChange={value => setActiveIndex(value.index)}>
        {pickings.map((picking, index) => (
          <CustomAccordionTab header={`Picking: ${picking}`} key={index}>
            <DataTable
              value={palletAreas.filter(palletArea => palletArea.picking_id === picking)}
              paginator={true}
              rows={10}
              globalFilter={globalFilter[index]}
              header={
                <CustomDataTableHeader
                  onChange={value =>
                    setGlobalFilter(prevState => {
                      prevState[index] = value
                      return [...prevState]
                    })
                  }
                />
              }
            >
              <Column field="id" header="Código" style={tableCellCentered()} />
              <Column field="status" header="Status" style={tableCellCentered()} />
              <Column field="endereco" header="Posição Estoque" style={tableCellCentered()} />
              <Column field="updated_at" header="Data Atualização" style={tableCellCentered()} />
            </DataTable>
          </CustomAccordionTab>
        ))}
      </Accordion>
    )
  }

  function ItensTab({ deliveryId, onError }) {
    //Hooks
    const [isLoading, setIsLoading] = useState(true)
    const [deliveryItems, setDeliveryItems] = useState([])
    const [globalFilter, setGlobalFilter] = useState('')
    const [observacaoModal, setObservacaoModal] = useState({
      show: false,
      text: '',
      label: '',
    })

    useEffect(() => {
      fetchDeliveryItems()
    }, [deliveryId])

    const exportarExcel = () => {
      try {
        if (deliveryItems.length === 0) throw new Error('Não existe entrega para exportação')
        const rows = [['Código', 'Produto', 'Peso', 'Valor R$', 'Volume', 'Unidade', 'Observação']]
        deliveryItems.forEach(e => {
          rows.push([
            e.product_code,
            e.product_name,
            e.total_weight,
            e.valor_item,
            e.volume,
            e.units,
            e.observacao || '',
          ])
        })

        gerarArquivoExcel('produtosPorEntrega', rows, 'produtos_entrega.xlsx')
      } catch (e) {
        dispatch(showMessageBox(null, errorHandler(e)))
      }
    }

    // Helpers
    const fetchDeliveryItems = async () => {
      try {
        setIsLoading(true)
        const fetchedItems = await CicloEntregaAcoesHttp.getDeliveryItemsByDeliveryId(deliveryId)
        console.log(fetchedItems)

        setDeliveryItems(fetchedItems)
      } catch (e) {
        onError(errorHandler(e))
      } finally {
        setIsLoading(false)
      }
    }

    const onOpenObservacaoModal = deliveryItem => {
      const label = `${deliveryItem.product_code} - ${deliveryItem.product_name}`
      setObservacaoModal({
        show: true,
        text: deliveryItem.observacao || '',
        label,
      })
    }

    const observacaoBodyTemplate = deliveryItem => {
      const texto = deliveryItem.observacao || '-'
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
          <span
            title={texto}
            style={{
              flex: 1,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {texto}
          </span>
          <span
            onClick={() => onOpenObservacaoModal(deliveryItem)}
            title="Ver observação completa"
            style={{
              flexShrink: 0,
              fontSize: '1.2rem',
              color: '#14B0BF',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              padding: '0 4px',
            }}
          >
            <FaEye />
          </span>
        </div>
      )
    }

    const priceBodyTemplate = deliveryItem => {
      return deliveryItem.valor_item
        ? deliveryItem.valor_item.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
        : deliveryItem.valor_item
    }

    const weightBodyTemplate = deliveryItem => {
      return deliveryItem.total_weight.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    }

    return isLoading ? (
      <div className="text-center">
        <Loading />
      </div>
    ) : (
      <>
        <div className="p-col-12">
          <Btn onClick={exportarExcel}>Exportar Excel</Btn>
        </div>
        <div className="p-col-12">
          <CustomDataTable
            value={deliveryItems}
            paginator={true}
            rows={10}
            header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
            globalFilter={globalFilter}
          >
            <Column field="product_code" header="Código" style={tableCellCentered(180)} />
            <Column field="product_name" header="Produto" />
            <Column
              field="total_weight"
              header="Peso"
              body={weightBodyTemplate}
              style={tableCellCentered(140)}
            />
            <Column
              field="valor_item"
              header="Valor R$"
              body={priceBodyTemplate}
              style={tableCellCentered(140)}
            />
            <Column field="volume" header="Volume" style={tableCellCentered(140)} />
            <Column field="units" header="Unidade" style={tableCellCentered(140)} />
            <Column field="observacao" header="Observação" body={observacaoBodyTemplate} />
          </CustomDataTable>
        </div>
        <CustomModal
          header="Observação"
          isVisible={observacaoModal.show}
          onClose={() => setObservacaoModal({ show: false, text: '', label: '' })}
          width={800}
        >
          <form className="p-grid">
            <div className="p-col-12">
              <span style={{ color: '#14B0BF', fontSize: '0.9rem' }}>Produto:</span>
              <div style={{ marginTop: 6 }}>{observacaoModal.label}</div>
            </div>
            <div className="p-col-12">
              <CustomInputTextArea
                label="Observação"
                marginTop={0}
                rows={10}
                disabled={true}
                value={observacaoModal.text}
                onChange={() => {}}
              />
            </div>
          </form>
        </CustomModal>
      </>
    )
  }
}

export default connect()(withRouter(EntregaDetalhes))
